import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faCaretLeft, faMoon, faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faPencil } from '@fortawesome/pro-solid-svg-icons';
import { ActionOptions } from 'src/app/models/application-models/action-options';

@Component({
  selector: 'app-common-action',
  templateUrl: './common-action.component.html',
  styleUrls: ['./common-action.component.css']
})
export class CommonActionComponent {
  @Input() options: ActionOptions<any>;
  @Output() updateList: EventEmitter<any> = new EventEmitter<any>();

  searchModel: string;

  faCaretLeft = faCaretLeft;
  faPlus = faPlus;
  faMoon = faMoon;
  faPencil = faPencil;
  faTimes = faTimes;

  filteredList: any;

  constructor() { }

  keyDownFunction(event: KeyboardEvent){
    if(event.key === 'Escape'){
      this.removeSearchText();
    }
  }

  itemInput(){
    if(this.searchModel.length < 1){
      this.filteredList = this.options.searchOptions.objectResponse;
      this.updateList.emit(this.filteredList);
      return [];
    } else {
      this.filteredList = this.options.searchOptions.objectResponse.filter(oneResponse => oneResponse[this.options.searchOptions.searchBy].toLowerCase().indexOf(this.searchModel.toLowerCase()) > -1);
      this.updateList.emit(this.filteredList);
      return this.filteredList.slice(0, 10);
    }
  }

  removeSearchText(){
    this.searchModel = '';
    this.itemInput();
  }
}
